import React from "react";

const InputBox = ({
  title,
  placeholder,
  area,
  value,
  onChange,
  mess,
  disabled,
}) => {
  return (
    <div style={{ flex: 1 }}>
      <p>{title}</p>
      <div style={{ width: "100%", overflow: "hidden", display: "flex" }}>
        {area ? (
          <textarea
            rows={3}
            value={value}
            onChange={onChange}
            className="form-control"
            style={{ resize: "vertical" }}
            placeholder="Write you Message here..."
          />
        ) : (
          <input
            disabled={disabled}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className="form-control"
          />
        )}
      </div>
      <p style={{ color: "red" }}>{mess}</p>
    </div>
  );
};

export default InputBox;
